module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan3-1-aa8d4cca5e8aada61144ed8098055b6a.webp";